<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <surveys-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import SurveysShowData from "./SurveysShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "SurveyShow",
        components: {CrudShow, SurveysShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'delivery.surveys.showing',
            }
        },
    }
</script>

